import { supabase } from './supabaseClient';

const BUCKET = 'documents-chantier';

function sanitizeFileName(name) {
  return name.replace(/[^a-zA-Z0-9._-]/g, '_');
}

export async function uploadChantierFile(file, chantierId, userId) {
  const storagePath = `${chantierId}/${Date.now()}_${sanitizeFileName(file.name)}`;

  const { error: uploadError } = await supabase.storage
    .from(BUCKET)
    .upload(storagePath, file, {
      contentType: file.type || 'application/octet-stream',
      upsert: false,
    });
  if (uploadError) throw uploadError;

  const { data, error } = await supabase
    .from('chantier_documents')
    .insert({
      chantier_id: chantierId,
      uploaded_by: userId,
      doc_type: 'autre',
      file_name: file.name,
      file_size: file.size ?? null,
      storage_path: storagePath,
    })
    .select('*')
    .single();

  if (error) throw error;
  return data;
}

const PHOTO_BUCKET = 'chantiers';

function fileExtension(name) {
  const dot = name.lastIndexOf('.');
  return dot > 0 ? name.slice(dot) : '';
}

export async function uploadChantierExtractionDocument(file, chantierId, docType) {
  const storagePath = `${chantierId}/${crypto.randomUUID()}_${docType}${fileExtension(file.name).toLowerCase()}`;

  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(storagePath, file, {
      contentType: file.type || 'application/octet-stream',
      upsert: false,
    });
  if (error) throw error;

  return {
    doc_type: docType,
    file_name: file.name,
    file_size: file.size ?? null,
    storage_path: storagePath,
  };
}

export async function removeStoredDocument(storagePath) {
  await supabase.storage.from(BUCKET).remove([storagePath]);
}

export async function uploadChantierPhoto(file) {
  const path = `temp-${Date.now()}-${crypto.randomUUID()}${fileExtension(file.name) || '.jpg'}`;

  const { error } = await supabase.storage
    .from(PHOTO_BUCKET)
    .upload(path, file, {
      contentType: file.type || 'image/jpeg',
      upsert: false,
    });
  if (error) throw error;

  const { data } = supabase.storage.from(PHOTO_BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

export function formatSize(bytes) {
  if (!bytes) return '—';
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}
